import React from 'react';

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className = '', ...props }, ref) => {
    return (
      <textarea
        ref={ref}
        className={`w-full bg-fieldiq-dark border border-fieldiq-border rounded-lg px-3 py-2.5 text-white text-sm placeholder-fieldiq-muted focus:outline-none focus:border-fieldiq-accent/50 transition-colors resize-none ${className}`}
        {...props}
      />
    );
  }
);
Textarea.displayName = 'Textarea';
